module.exports = __webpack_public_path__ + "videos/alter-ego_9-16.0ce5657.mp4";